<template>
  <el-checkbox v-bind="$attrs" :size="sizeMap[props.size]" :class="[style.checkbox, `checkbox-${props.size}`]">
    <template v-if="slots.default">
      <slot />
    </template>
    <template v-else-if="props.label">
      {{ props.label }}
    </template>
  </el-checkbox>
</template>

<script setup lang="ts">
const slots = useSlots();
const props = defineProps({
  size: {
    validator(value: string) {
      return ['max', 'large', 'default', 'small'].indexOf(value) > -1;
    },
    type: String,
    default: 'default'
  },
  label: {
    type: String,
    default: ''
  }
});

const sizeMap: any = reactive({
  max: 'max',
  large: 'large',
  default: 'default',
  small: 'small',
  mini: 'small'
});

</script>

<style lang="scss" module="style">
.checkbox {
  --el-checkbox-input-border: 1px solid var(--gray-gray6);
  --primary-primary3:var(--gray-gray10);
  --el-checkbox-disabled-checked-input-fill: var(--gray-gray2);
  --el-checkbox-disabled-checked-input-border-color: var(--gray-gray2);
  --el-checkbox-disabled-checked-icon-color:var(--gray-gray0);
  --el-checkbox-disabled-input-fill: none;
  --el-checkbox-disabled-border-color: var(--gray-gray2);
  --el-checkbox-checked-icon-color:var(--gray-gray0);
  --el-checkbox-input-border-color-hover: var(--gray-gray10);

  :global(.el-input__inner::placeholder) {
    color: var(--text-text4);
  }

  &:global {

    &.el-checkbox .el-checkbox__label{
      font-size: var(--el-checkbox-font-size);
      color:var(--text-text2);
      padding-inline-start:4px;
    }

    // &.el-checkbox .el-checkbox__inner{
    //   height: 14px;
    //   width: 14px;
    // }
    
  }

  :global(.el-checkbox__inner::after) {
      border-width: 1.5px;
    }
}

:global {
  .checkbox {

    &-max {
      --el-checkbox-font-size:var(--font-size-max);
      --el-checkbox-font-weight:var(--font-weight-max);
    }

    &-large {
      --el-checkbox-font-size:var(--font-size-large);
      --el-checkbox-font-weight:var(--font-weight-large);
    }

    &-default {
      --el-checkbox-font-size:var(--font-size-default);
      --el-checkbox-font-weight:var(--font-weight-default);
    }

    &-small {
      --el-checkbox-font-size:var(--font-size-small);
      --el-checkbox-font-weight:var(--font-weight-small);
      .el-checkbox__inner::after{
        border-width: 1px;
      }
    }
    &-mini {
      --el-checkbox-font-size:var(--font-size-mini);
      --el-checkbox-font-weight:var(--font-weight-mini);
      .el-checkbox__inner::after{
        border-width: 1px;
      }
    }
  }
}
</style>
